import React from 'react'
import './theme.scss'

export default function PrimaryButton({ clickAction, label, disabled }) {
    const className = disabled
        ? 'button button--primary button--primary-disabled'
        : 'button button--primary'
    return (
        <div className={className} onClick={clickAction}>
            {label}
        </div>
    )
}
